var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"validation"},_vm._l(([].concat(_vm.message)),function(m){return _c('li',{key:m},[_c('AlertIcon'),_vm._v("\n    "+_vm._s(m)+"\n  ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }